var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`${_vm.bg_style}`),attrs:{"id":"app"}},[(!_vm.$route.path.includes('/auth/'))?_c('Navigation'):_vm._e(),(_vm.user && _vm.artist_role)?_c('el-aside',{class:{ toggled: _vm.is_toggled }},[_c('SidebarArtist')],1):_vm._e(),(_vm.user && _vm.label_role)?_c('el-aside',{class:{ toggled: _vm.is_toggled }},[_c('SidebarLabel')],1):_vm._e(),(_vm.user && _vm.content_role)?_c('el-aside',[_c('SidebarContent')],1):_vm._e(),_c('el-main',{class:{
      toggled: _vm.is_toggled,
      w100: _vm.user && !_vm.$route.path.includes('/auth/') && _vm.admin_role,
      'user-main': _vm.user && !_vm.$route.path.includes('/auth/') && !_vm.admin_role,
      'user-main-label-dash':
        _vm.user &&
        !_vm.$route.path.includes('/auth/') &&
        !_vm.$route.path.includes('/my-artists/artist') &&
        !_vm.artist_role
    }},[(
        (_vm.user && _vm.label_role) ||
          (_vm.user && _vm.artist_role) ||
          (_vm.user && _vm.content_role)
      )?_c('el-container',{class:{
      'aux-container': _vm.user && _vm.$route.path.includes('content-id')
    }},[_c('router-view')],1):_c('div',[_c('router-view')],1)],1),_c('Footer'),(_vm.isRefresh)?_c('button',{staticClass:"new-content",on:{"click":_vm.update}},[_vm._v("\n    New content is available. Click to refresh.\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }